export function removePrefix(text: string, prefix: string) {
  if (text.startsWith(prefix)) {
    return text.slice(prefix.length)
  }
  return text
}
